import { forwardRef } from "react";

import { getImgUrlReplaceBe } from "@/shared.utils/image";
import { Separator } from "@/shared-web.ui/ui.separator";
import { cn } from "@/shared-web.ui/util.cn";

const Container = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) => {
  const { className, ...containerProps } = props;
  return (
    <div
      className={cn(
        "relative",
        className,
      )}
      ref={ref}
      {...containerProps}
    />
  );
});
Container.displayName = "BlogDetailHeadContainer";

const Button = forwardRef<
  HTMLButtonElement,
  React.HTMLAttributes<HTMLButtonElement>
>((props, ref) => {
  return (
    <button
      type="button"
      ref={ref}
      {...props}
    />
  );
});
Button.displayName = "BlogDetailHeadButton";

const ButtonContainer = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (props, ref) => {
    const { className, ...buttonProps } = props;

    return (
      <div
        ref={ref}
        className={cn(
          "flex items-center justify-center",
          className,
        )}
        {...buttonProps}
      />
    );
  },
);
ButtonContainer.displayName = "BlogDetailHeadButtonContainer";

interface BlogDetailHeadProps {
  author: string;
  imageUrl: string;
  slug: string;
  subTitle: string;
  title: string;
}
const Content = (props: BlogDetailHeadProps) => {
  const {
    imageUrl,
    title,
    author,
    subTitle,
    slug,
  } = props;
  return (
    <>
      <div
        aria-hidden="true"
        className="absolute inset-0 overflow-hidden"
      >
        <img
          src={
            getImgUrlReplaceBe({
              imgPath: imageUrl,
              transformation: [
                {
                  width: 1280,
                  quality: 80,
                  crop: "at_max",
                },
              ],
            })
          }
          alt={title}
          className={`
            size-full object-cover object-center
          `}
        />
      </div>
      <div
        aria-hidden="true"
        className={`
          absolute inset-0 bg-black-a8 opacity-50
        `}
      />
      <div className={`
        relative mx-auto flex max-w-3xl flex-col
        items-center gap-2 px-6 py-16 text-center
        lg:px-0
        sm:py-32
      `}
      >
        <h1 className={`
          text-8 font-medium text-white-a12
        `}
        >
          {title}
        </h1>
        <p className="text-6 text-white-a12">
          {subTitle}
        </p>
        <Separator
          size="3"
          orientation="horizontal"
          className="bg-white-a12 my-4"
        />
        <p className="text-4 text-white-a12">
          {author}
        </p>
      </div>
    </>
  );
};

const PrimBlogDetailHead = {
  Container,
  Content,
  Button,
  ButtonContainer,
};

export { type BlogDetailHeadProps, PrimBlogDetailHead };
